import Container from 'app/components/common/Container';
import OurServicesCard from 'app/components/Services/OurServicesCard';
import { apiEndpoint } from 'app/scripts/fetch';
import { createMarkup } from 'app/scripts/utils';

export default function ExperiencedTeam({
  section,
  section_content,
  isProcess = false,
}) {
  let items = section_content?.map(item => ({
    icon: {
      src: apiEndpoint(item?.image?.data?.attributes?.url) ?? '/',
      alt: item?.image?.data?.attributes?.name,
      width: item?.image?.data?.attributes?.width,
      height: item?.image?.data?.attributes?.height,
    },
    h1: item.h || item.text,
    p: item?.p,
    link: item?.link,
  }));
  return (
    <Container className="md:py-[75px] py-[35px]">
      <div className="text-center md:mb-[34px] mb-[30px]">
        <h4 className="font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight mb-2">
          {section?.h1_purple} {section?.h1_black}
        </h4>
        {section?.body ? (
          <div
            className="max-w-[1000px] mx-auto md:text-[18px] text-[14px] text-[#000000]"
            dangerouslySetInnerHTML={createMarkup(section?.body)}
          ></div>
        ) : (
          <p className="max-w-[1000px] mx-auto md:text-[16px] text-[14px] text-[#000000]">
            {section?.p}
          </p>
        )}
      </div>
      <div>
        <OurServicesCard
          isService={true}
          list={items}
          center={true}
          rowItems={isProcess ? 3 : 4}
          className="py-8 transition-colors ease-in duration-200 border border-transparent hover:border-primary"
        />
      </div>
    </Container>
  );
}
